export class ApiConstants
{
    public static largeODataTop = 2000;
}
